import { Champ } from '@apg-stats/apg-core/lib/champs';
import produce, { Draft } from 'immer';
import { Dispatch } from 'react';
import { DispatchObject } from '../domain/dispatch-object';
import { Tool } from '../domain/tools.interface';

export type DispatchApp = Dispatch<DispatchObject<AppActions>>;

export enum AppActions {
  IsFetching = 'IS_FETCHING',
  FinishedFetching = 'FINISHED_FETCHING',
  ErrorFetching = 'ERROR_FETCHING',
  SessionExpired = 'SESSION_EXPIRED',
  SetTools = 'SET_TOOLS',
  SetUserToken = 'SET_USER_TOKEN',
  SetChamps = 'SET_CHAMPS',
  ClearData = 'CLEAR_DATA'
}

export interface UserToken {
  _id: string,
  username: string,
  email: string,
  countryCode: string,
  role: string
}

export interface AppState {
  isFetching: boolean;
  pendingFetches: number;
  sessionExpired: boolean;
  tools: Tool[] | null;
  userToken: UserToken;
  champs: Champ[];
  error: null;
}

export const initialState: AppState = {
  isFetching: false,
  pendingFetches: 0,
  sessionExpired: false,
  tools: null,
  userToken: {
    _id: '',
    username: '',
    email: '',
    countryCode: '',
    role: ''
  },
  champs: [],
  error: null,
};

export const appReducer = produce((draft: Draft<AppState>, { type, payload }: DispatchObject<AppActions>) => {
  switch (type) {
    case AppActions.IsFetching:
      draft.pendingFetches += 1;
      draft.isFetching = true;
      draft.error = null;
      break;
    case AppActions.FinishedFetching:
      draft.pendingFetches -= 1;
      draft.isFetching = false;
      break;
    case AppActions.ErrorFetching:
      draft.pendingFetches = 0;
      draft.isFetching = false;
      draft.error = payload;
      break;
    case AppActions.SessionExpired:
      draft.sessionExpired = true;
      break;
    case AppActions.SetTools:
      draft.tools = payload;
      break;
    case AppActions.SetUserToken:
      draft.userToken = payload;
      break;
    case AppActions.SetChamps:
      draft.champs = payload;
      break;
    case AppActions.ClearData:
      return initialState;
    default:
      throw new Error(`Unknown global action type: ${type}`);
  }
});
